// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__11jfY","button__icon":"IconButton_button__icon__Z1FBg"};